export default __webpack_public_path__ + "static/media/Bed_Icon_B.42153964.svg";